<nb-actions size="small">
  <nb-action icon="eye-outline" [link]="['/pages/informes/detalle',tipoInforme, reportid]"></nb-action>

</nb-actions>

